<template>
  <div class="mt-10 xl:mt-0">
    <cancel-subscription-popup
      :data-to-show="stateCancelSubscriptionPopupDisplayed"
      @close="displayCancelSubscriptionPopup(-1)"
      :end-date="expiryDate"
      @cancelSubscription="cancelSubscription()"
    />
    <!-- --------------- BEGIN Page Mes Abonnements --------------- -->
    <div
      class="xl:m-15 flex justify-center"
      v-show="isAdminPay"
    >
      <div
        class="w-5/12 mt-5 py-10 px-10 border text-center rounded-lg"
        :class="{
          'bg-gray-100 border-gray-600': abon === 'Gratuit',
          'bg-indigo-100 border-indigo-600': abon === 'Pilote',
          'bg-pink-100 border-pink-600': abon === 'Expert',
        }"
      >
        <h3
          :class="{
            'text-gray-900': abon === 'Gratuit',
            'text-indigo-600': abon === 'Pilote',
            'text-pink-600': abon === 'Expert',
          }"
        >
          {{ abon }}
        </h3>
        

        <br />

        <p class="text-base">
          Vous bénéficiez de l'offre « {{ abon }} »
        </p>
        <p
          class="text-base"
          v-if="selectedPlan != 'freemium'"
        >
          en « Facturation
          {{
            selectedPlan === 'yearly'
              ? 'annuelle'
              : selectedPlan === 'monthly_with_commitment'
                ? 'mensuelle avec engagement de 1 an'
                : selectedPlan === 'monthly_without_commitment'
                  ? 'mensuelle sans engagement'
                  : selectedPlan === 'personalized'
                    ? 'personnalisée'
                    : 'par défaut'
          }}
          »
        </p>
        <p
          class="text-base"
          v-if="selectedPlan != 'freemium' && firstSubscription"
        >
          depuis le
          {{
            ('0' + new Date(firstSubscription.created_at).getDate()).slice(-2)
          }}/{{
            (
              '0' +
              (new Date(firstSubscription.created_at).getMonth() + 1)
            ).slice(-2)
          }}/{{ new Date(firstSubscription.created_at).getFullYear() }}.
        </p>

        <br />

        <p class="text-base">
          Détail de vos carnets de parcours
        </p>
        <ul class="text-indigo-600 text-base font-light list-disc list-inside">
          <li v-if="selectedPlan != 'freemium'">
            <span class="text-gray-600">Total: {{ volumeNeopass.total }}</span>
          </li>
          <li>
            <span class="text-gray-600">Créés: {{ volumeNeopass.created }}</span>
          </li>
          <li>
            <span class="text-gray-600">Actifs: {{ volumeNeopass.active }}</span>
          </li>
          <li>
            <span class="text-gray-600">Sortis: {{ volumeNeopass.out || 0 }}</span>
          </li>
          <!-- <li>Inactifs: {{volumeNeopass.inactive}}</li> -->
          <!-- <li>Suspendus: {{volumeNeopass.suspended}}</li> -->
          <li v-if="selectedPlan != 'freemium'">
            <span class="text-gray-600">Disponibles: {{ volumeNeopass.available }}</span>
          </li>
        </ul>

        <div
          class="mt-10"
          v-if="
            selectedPlan != 'freemium' &&
              firstSubscription &&
              !firstSubscription.ends_at
          "
        >
          <h5 class="text-indigo-600">
            Prochain prélèvement
          </h5>
          <!-- if current day exceed billing day : display next month -->
          <div
            v-if="firstSubscription"
            class="text-base font-light"
          >
            <p class="text-gray-600 text-base font-light">
              Date: {{ expiryDate }}.
            </p>
          </div>
          <p class="text-gray-600 text-base font-light">
            Montant:
            {{
              (
                priceUnit *
                nbNeopass *
                (selectedPlan === 'yearly' ? 11 : 1)
              ).toLocaleString(undefined, { minimumFractionDigits: 2 })
            }}€
          </p>

          <br />

          <div v-if="paymentMethods.length > 0">
            <h5 class="text-indigo-600">
              Moyen de paiement
            </h5>
            <p class="text-gray-600 text-base">
              {{ paymentMethods[0].brand.charAt(0).toUpperCase()
              }}{{ paymentMethods[0].brand.slice(1) }} finissant par
              {{ paymentMethods[0].last_four }}
            </p>

            <div
              v-if="false"
              @click.stop="removePaymentMethod(paymentMethods[0].id)"
              class="cursor-pointer flex items-center justify-center mt-3"
            >
              <div
                class="inline-block py-1 px-1 border rounded-full border-opacity-25 border-pink-600 bg-pink-300 group-hover:border-pink-600"
              >
                <icon
                  name="close"
                  class="text-pink-600 h-1.5 w-1.5"
                />
              </div>
              <p class="inline-block text-sm font-light text-gray-600 ml-2">
                Supprimer un moyen de paiement
              </p>
            </div>
          </div>

          <div
            v-else-if="false"
            @click="SET_TABDISPLAY('majBancaire')"
            class="cursor-pointer"
          >
            <div
              class="inline-block -mb-1 py-1 px-1 border rounded-full border-opacity-25 border-teal-600 bg-teal-300 group-hover:border-teal-600"
            >
              <icon
                name="plus"
                class="text-teal-600 h-1.5 w-1.5"
              />
            </div>
            <p class="inline-block text-2sm text-gray-600">
              Ajouter un nouveau moyen de paiement
            </p>
          </div>
        </div>

        <div
          class="text-gray-600 text-base font-light mt-10"
          v-if="firstSubscription && firstSubscription.ends_at"
        >
          Votre abonnement s'arrêtera le {{ expiryDate }}.
        </div>

        <router-link
          :to="{ name: 'Subscriptionchoice' }"
          class="mt-15 flex justify-center"
        >
          <action-button
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="Changer d'offre"
            :uppercase="true"
            icon="arrow-circle-right"
            :responsive="false"
            :right="true"
            :enable-action="false"
          />
        </router-link>
        <div class="flex justify-center my-10">
          <illustration name="illustration-offre" />
        </div>

        <div
          class="text-base text-gray-600 font-light"
          v-if="firstSubscription && !firstSubscription.ends_at"
        >
          Cliquer
          <span
            @click="displayCancelSubscriptionPopup(1)"
            class="cursor-pointer text-indigo-600 underline"
          >ici</span>
          pour désactiver le renouvellement automatique en fin de contrat.
        </div>
      </div>
    </div>
    <!-- --------------- END Page Mes Abonnements --------------- -->

    <!-- --------------- BEGIN Page Confirm cancel subscription ---------------
        <div class="m-15 min-h-halfscreen text-center" v-show="tab_display == 'confirmCancel'">
            <h3 class="mb-10">Confirmation de changement d'abonnement</h3>
            <div class="mb-5">En revenant à une formule Gratuite, vous n'aurez plus accès aux modules suivants : </div>
            <ul class="list-disc list-inside mb-5">
                <li>Compétences personnelles</li>
                <li>Compétences Socio-professionnelles</li>
                <li>Plan d'accompagnement</li>
                <li>Plan SEA</li>
                <li>Préconisation emploi/stage</li>
                <li>Fiches de poste</li>
                <li>Cartographies</li>
                <li>Modèles de pages</li>
                <li>Suivi de parcours</li>
            </ul>
            <div @click="cancelSubscription()">
                <action-button
                    borderColor="border-transparent"
                    textColor="text-white"
                    textColorHover="hover:text-pink-600"
                    bgColor="bg-pink-600"
                    bgColorHover="hover:bg-pink-300"
                    bgColorSquare="bg-pink-600"
                    iconColor="text-white"
                    iconColorHover="hover:text-pink-600"
                    libelle="Confirmer l'annulation de son abonnement"
                    icon="close"
                    :right="true"
                />
            </div>
        </div>
        --------------- END Page Confirm cancel subscription --------------- -->
  </div>
</template>

<script>
import axios from './../../api';
import store from './../../store';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Constants from './../../constants';

import Illustration from './../../components/Illustration';
import Icon from './../../components/Icon';
import ActionButton from './../../components/ActionButton';
import Popup from './../../components/Popup';
import InputText from './../../components/Inputs/InputText';
import CircleButton from './../../components/CircleButton';

import CancelSubscriptionPopup from './popup/CancelSubscriptionPopup.vue';

export default {
  name: 'Subscription',

  components: {
    Icon,
    ActionButton,
    Illustration,
    InputText,
    CircleButton,
    Popup,
    CancelSubscriptionPopup,
  },

  data() {
    return {
      constants: Constants,

      /* BEGIN datas for "mes abonnements" */
      subscriptions: [],

      nbNeopass: 1,
      stripeAPIToken: process.env.MIX_STRIPE_KEY,
      stripe: '',
      elements: '',
      card: '',
      intentToken: '',

      name: '',
      addPaymentStatus: 0,
      addPaymentStatusError: '',

      paymentMethods: [],
      paymentMethodsLoadStatus: 0,
      paymentMethodSelected: {},

      //        selectedPlan: '',

      volumeNeopass: {
        total: 0,
        created: 0,
        active: 0,
        inactive: 0,
        suspended: 0,
        available: 0,
      },
      /* END datas for "mes abonnements" */

      stateCancelSubscriptionPopupDisplayed: -1,
    };
  },

  mounted() {
    this.includeStripe(
      'js.stripe.com/v3/',
      function () {
        this.configureStripe();
      }.bind(this)
    );

    this.loadIntent();
    this.loadPaymentMethods();

    this.loadSubscriptions();
  },

  methods: {
    ...mapMutations({
      SET_TABDISPLAY: 'account/SET_TABDISPLAY',
      SET_SAVING: 'account/SET_SAVING',
    }),
    /*
        Includes Stripe.js dynamically
        */
    includeStripe(URL, callback) {
      let documentTag = document,
        tag = 'script',
        object = documentTag.createElement(tag),
        scriptTag = documentTag.getElementsByTagName(tag)[0];
      object.src = '//' + URL;

      if (callback) {
        object.addEventListener(
          'load',
          function (e) {
            callback(null, e);
          },
          false
        );
      }

      scriptTag.parentNode.insertBefore(object, scriptTag);
    },

    /*
        Configures Stripe by setting up the elements and
        creating the card element.
        */
    configureStripe() {
      this.stripe = Stripe(this.stripeAPIToken);
    },

    /*
        Loads the payment intent key for the user to pay.
        */
    loadIntent() {
      axios.get('/api/subscription/setup-intent').then(
        function (response) {
          this.intentToken = response.data;
        }.bind(this)
      );
    },

    submitPaymentMethod() {
      if (this.isAdminPay) {
        this.SET_SAVING(true);
        console.log('Wait...Submit payment method');
        this.addPaymentStatus = 1;
        this.stripe
          .confirmCardSetup(this.intentToken.client_secret, {
            payment_method: {
              card: this.card,
              billing_details: {
                name: this.name,
              },
            },
          })
          .then(
            function (result) {
              console.log('wait...confirm card setup');
              if (result.error) {
                console.log(
                  'confirm card setup : ERROR : ' + result.error.message
                );
                this.addPaymentStatus = 3;
                this.addPaymentStatusError = result.error.message;
              } else {
                console.log('confirm card setup : OK');
                this.savePaymentMethod(result.setupIntent.payment_method);
                this.addPaymentStatus = 2;
                this.card.clear();
                this.name = '';
                if (this.tab_display == 'bancaire') {
                  this.SET_TABDISPLAY('confirmPayment');
                }
              }
            }.bind(this)
          );
      }
    },

    /*
        Saves the payment method for the user and
        re-loads the payment methods.
        */
    savePaymentMethod(method) {
      if (this.isAdminPay) {
        this.SET_SAVING(false);
        store.commit('app/SET_LOADING', true);

        axios
          .post('/api/subscription/payments', {
            payment_method: method,
          })
          .then(
            function () {
              this.loadPaymentMethods();
            }.bind(this)
          );
      }
    },

    /*
        Loads all of the payment methods for the
        user.
        */
    loadPaymentMethods() {
      store.commit('app/SET_LOADING', true);
      this.paymentMethodsLoadStatus = 1;
      axios
        .get('/api/subscription/payment-methods')
        .then(
          function (response) {
            this.paymentMethods = response.data;
            this.paymentMethodsLoadStatus = 2;
            store.commit('app/SET_LOADING', false);
          }.bind(this)
        )
        .catch((error) => {
          console.log('ERRRR:: ', error);
          store.commit('app/SET_LOADING', false);
        });
    },

    removePaymentMethod(paymentID) {
      if (this.isAdminPay) {
        axios
          .post('/api/subscription/remove-payment', {
            id: paymentID,
          })
          .then(
            function (response) {
              this.loadPaymentMethods();
            }.bind(this)
          );
      }
    },

    loadSubscriptions() {
      axios.get('/api/subscription/subscription').then((response) => {
        console.log('wait...loadSubscriptions');
        this.nbNeopass = 0;

        if (response.data) {
          //if subscription exists
          this.subscriptions = response.data;

          //perhaps have multi subscriptions
          this.subscriptions.forEach((sub) => {
            if (sub.quantity > 0) {
              this.nbNeopass += sub.quantity;
            }
          });
          store.commit('auth/SET_SUBSCRIPTION', this.subscriptions[0]);
        }
        if (this.nbNeopass > 0) {
          //            this.selectedPlan = process.env.MIX_PRICE_PLAN;
          this.volumes(this.nbNeopass);
        } else {
          this.volumes(1);
          this.nbNeopass = 1;
          //            this.selectedPlan = 'freemium';
        }
      });
    },

    cancelSubscription() {
      if (!this.isAdminPay) {
        this.stateCancelSubscriptionPopupDisplayed = 100;
        return;
      }

      store.commit('app/SET_LOADING', true);

      axios
        .post('/api/subscription/cancel-subscription')
        .then((response) => {
          this.loadSubscriptions();
          this.SET_TABDISPLAY('abonnements');
          this.stateCancelSubscriptionPopupDisplayed = 2;
          store.commit('app/SET_LOADING', false);
        })
        .catch((err) => {
          console.log(err);
          store.commit('app/SET_LOADING', false);
        });
    },

    volumes(total) {
      axios.get('/api/allNeopass').then((response) => {
        let allPass = response.data;

        this.volumeNeopass.total = total;
        this.volumeNeopass.created = allPass.filter(
          (p) => p.deleted_at == null
        ).length;
        this.volumeNeopass.active = allPass.filter(
          (p) => p.deleted_at == null
        ).length; //active = linked with company
        this.volumeNeopass.out = allPass.filter(
          (p) => false
        ).length;
        this.volumeNeopass.inactive = allPass.filter(
          (p) => p.deleted_at != null
        ).length;
        this.volumeNeopass.suspended = allPass.filter(
          (p) => p.is_active == 0 && p.deleted_at == null
        ).length;
        this.volumeNeopass.available =
          this.volumeNeopass.total - this.volumeNeopass.active >= 0
            ? this.volumeNeopass.total - this.volumeNeopass.active
            : 0;
      });
    },

    displayCancelSubscriptionPopup(state) {
      this.stateCancelSubscriptionPopupDisplayed = state;
    },
  },

  computed: {
    ...mapGetters({
      isAdminPay: 'account/isAdminPay',
      tab_display: 'account/tabDisplay',
      saving: 'account/saving',
      user: 'auth/user',
    }),

    firstSubscription: function () {
      if (!Array.isArray(this.subscriptions)) {
        return null;
      }
      return this.subscriptions.sort((a, b) => {
        // ici pour faire au plus vite au compare des chaines
        // mais il faudrait utiliser la class Date()
        return a.created_at > b.created_at ? 1 : -1;
      })[0];
    },

    selectedPlan: function () {
      if (this.subscriptions.length === 0) {
        return 'freemium';
      }
      switch (this.subscriptions[0].stripe_plan) {
      case process.env.MIX_PRICE_PLAN_YEARLY:
      case process.env.MIX_OLD_PRICE_PLAN_YEARLY:
        return 'yearly';

      case process.env.MIX_PRICE_PLAN_MONTHLY_WITH_COMMITMENT:
      case process.env.MIX_OLD_PRICE_PLAN_MONTHLY_WITH_COMMITMENT:
        return 'monthly_with_commitment';

      case process.env.MIX_PRICE_PLAN_MONTHLY_WITHOUT_COMMITMENT:
      case process.env.MIX_OLD_PRICE_PLAN_MONTHLY_WITHOUT_COMMITMENT:
        return 'monthly_without_commitment';

      case process.env.MIX_PRICE_PLAN_CLIENT_PC:
        return 'personalized';

      default:
        return 'personalized';
      }
    },

    abon: function () {
      if (this.company.has_pro_subscription) {
        return 'Pilote';
      }

      if (this.company.has_ultimate_subscription) {
        return 'Expert';
      }

      return 'Gratuit';
    },

    company: function () {
      return this.user.companies.length === 0 ? null : this.user.companies[0];
    },

    expiryDate: function () {
      return (
        (new Date(this.company.expiry_date).getDate() < 10 ? '0' : '') +
        new Date(this.company.expiry_date).getDate() +
        '/' +
        (new Date(this.company.expiry_date).getMonth() + 1 < 10 ? '0' : '') +
        (new Date(this.company.expiry_date).getMonth() + 1) +
        '/' +
        new Date(this.company.expiry_date).getFullYear()
      );
    },

    priceUnit: function () {
      // Paliers de prix en fonction du nombre de Neopass choisi
      let milestones = ['yearly', 'monthly_with_commitment'].includes(
        this.selectedPlan
      )
        ? Constants.MILESTONES_WITH_COMMITMENT_UNIT_PRICE
        : Constants.MILESTONES_WITHOUT_COMMITMENT_UNIT_PRICE;

      return (
        milestones[
          Object.keys(milestones)
            .filter((qt) => parseInt(this.nbNeopass) >= qt)
            .reverse()[0]
        ] || Object.values(milestones)[0]
      );
    },
    pu: function () {
      // Prix unitaire avec engagement (sous forme décimale à 2 chiffres après la virgule)
      return this.priceUnit.toLocaleString(undefined, {
        minimumFractionDigits: 2,
      });
    },
  },
};
</script>
